module.exports = __webpack_public_path__ + "pw.f05bd392fb752707d9c7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pw.svg
// module chunks = styles